import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const Contact = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  return (
    <div>
      <div>
        {loaderStatus ? (
          <div className="loader-container">
            <MagnifyingGlass
              visible={true}
              height="100"
              width="100"
              ariaLabel="magnifying-glass-loading"
              wrapperStyle={{}}
              wrapperclassName="magnifying-glass-wrapper"
              glassColor="#c0efff"
              color="#0aad0a"
            />
          </div>
        ) : (
          <>
            <ScrollToTop />
            <section className="my-lg-14 my-8">
              <div className="container">
                <div className="row">
                  <div className="offset-lg-2 col-lg-8 col-12">
                    <div className="mb-8">
                      <h1 className="h3">Contact Almoune</h1>
                      <p className="lead mb-0">
                        Une question sur un produit, une commande ou la boutique
                        en ligne ? Utilisez ce formulaire ou contactez
                        directement l'epicerie au +33 9 81 39 14 33.
                      </p>
                    </div>
                    <form className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prenom</label>
                        <input type="text" className="form-control" placeholder="Votre prenom" />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input type="text" className="form-control" placeholder="Votre nom" />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label className="form-label">Sujet</label>
                        <input type="text" className="form-control" placeholder="Commande, produit, livraison..." />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input type="text" className="form-control" placeholder="Votre email" />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Telephone</label>
                        <input type="text" className="form-control" placeholder="+33 ..." />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label className="form-label">Message</label>
                        <textarea rows={3} className="form-control" placeholder="Votre message" defaultValue={""} />
                      </div>
                      <div className="col-md-12">
                        <Link to="#" className="btn btn-primary">Envoyer</Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default Contact;
